<template>
    <div class="wrapper" >
        <MercenaryHeader  v-if="!isModify" :title="''" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <MercenaryHeader  v-else :title="(days && !isCopy ? '매주 반복중인 트레이닝 ' : '') + ' ' + (isCopy ? '복사' : '수정')" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <!--<div v-if="mode === MAKE_SCHEDULE_MODE.DEFAULT" style="padding: 20px 20px 0px; padding-bottom: 10px;">-->
            <!--<div @click="close" style="margin-top: 10px; display: flex; align-items: center; position: relative; ">-->
                <!--<img :src="require('@/assets/img/black_x_btn_new.png')" style="width: 20px" />-->
                <!--<div v-if="isModifyMemberTalkSchedule" style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">스케줄 수정하기</div>-->
                <!--<div v-else-if="isOpen" style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">수업 스케줄 {{ scheduleIdx ? '수정하기' : '만들기' }}</div>-->
                <!--<div v-else style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">수업 스케줄 만들기</div>-->
            <!--</div>-->
        <!--</div>-->
        <!--<div v-else style="padding: 0 12px; padding-bottom: 16px; border-bottom: 1px solid #f5f5f5;">-->
            <!--<div @click="close" style="display: flex; align-items: center; position: relative">-->
                <!--<img :src="require('@/assets/img/recent_x_btn.png')" style="width: 42px" />-->
                <!--<div v-if="!isModify" style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">트레이닝{{days ? '[매주]' : ''}} 만들기</div>-->
                <!--<div v-else style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">{{days && !isCopy ? '매주 반복중인 트레이닝 ' : ''}} {{isCopy ? '복사하기' : '수정하기'}}</div>-->
            <!--</div>-->
        <!--</div>-->
        <div ref="main_wrap" class="main_wrap">
            <div class="step1">
                <div class="input_text title">
                    <div class="common_text">트레이닝 제목</div>
                    <input @input="handleTitleLength" v-model="makeScheduleInfo.title" placeholder="트레이닝 이름을 입력하세요" class="text_area" type="text">
                    <div class="count_text">{{ makeScheduleInfo.title.length }} / 30</div>
                </div>
                <div v-if="isOpen" class="input_text contents">
                    <div class="common_text">트레이닝 소개</div>
                    <textarea style="resize: none; line-height: 24px;" v-model="makeScheduleInfo.contents" placeholder="트레이닝을 소개해주세요" class="text_area" type="text"></textarea>
                    <div class="count_text">{{ makeScheduleInfo.contents.length }} / 200</div>
                </div>
                <div v-else class="input_text contents">
                    <div class="common_text">소개</div>
                    <div style="position: relative;">
                        <Transition v-if="!isJoin" name="fade">
                            <div v-if="isShowPopup" class="guide_box" style="position: absolute;">
                                <div class="triangle" style=""></div>
                                <div style="display: flex; align-items: center; gap: 10px; justify-content: space-between;">
                                    <div style="flex-shrink: 0; font-weight: 700; font-size: 12px; color: #606060;">사커하우 추천 문구</div>
                                    <div @click="closePopup" style="width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;">
                                        <img style="width: 8px;" :src="require('@/assets/img/reco_popup.png')" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div style="font-size: 12px; color: var(--color-main); font-weight: 500; line-height: 17px; white-space: nowrap;">“내일 경기 용병 한 분 구합니다.”<br>“골키퍼 한 분 모십니다”</div>
                                </div>
                            </div>
                        </Transition>
                        <textarea style="line-height: 20px;" @input="handleIntroLength" v-model="makeScheduleInfo.contents" placeholder="스케줄을 설명해주세요" class="text_area" name="" id="" cols="30" rows="10"></textarea>
                    </div>
                    <div class="count_text">{{ makeScheduleInfo.contents.length }} / 500</div>
                </div>
            </div>
            <!-- <div v-if="!isJoin" class="step2">
                <div style="margin-bottom: 20px;">
                    <div class="common_text">수업 유형</div>
                    <div style="display: flex; margin-top: 4px; gap: 8px; flex-wrap: wrap;">
                        <div style="white-space: nowrap;" v-for="each, i in classType" :key="i">
                            <MercenaryModalBtn :isActive="each === makeScheduleInfo.classType" :clickEvent="() => { setClassType(each) }" :btnName="each"></MercenaryModalBtn>
                        </div>
                    </div>
                    <div class="only_one">1개만 선택할 수 있습니다.</div>
                </div>
            </div> -->
            <div style="margin-bottom: 20px;" v-if="makeScheduleInfo.is_group_buying">
                <div style="margin-top: 16px;" v-if="makeScheduleInfo.is_group_buying">
                    <div style="margin-bottom: 8px;" class="common_text">공동구매 수업 비용</div>
                    <div style="display: flex; align-items: center; gap: 12px; margin-top: 6px; margin-bottom: 8px;">
                        <input @keyup="comma3" class="class_fee" v-model="makeScheduleInfo.groupClassCost" style="border-radius: 12px; width: 289px; border: 1px solid #d9d9d9; outline: none; padding: 12px;" placeholder="직접 입력" type="tel">
                        <div style="font-weight: 500; font-size: 14px">원</div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <span style="display: inline-block; width: 4px; height: 4px; border-radius: 50%; background-color: #210f03;"></span>
                        <div style="font-size: 12px;font-weight: 500;">추천 공동구매 수업 비용</div>
                    </div>
                    <div class="hide_scroll" style="display: flex; gap: 4px; overflow-x: scroll; margin: 0 -12px; padding: 0 12px; margin-top: 8px; ">
                        <div @click="setGroupClassCost(each)" v-for="each, i in recommendClassDuesList" :key="i" style="line-height: 24px; background-color: #fff; flex-shrink: 0; padding: 4px; text-align: center; width: 93px; border: 1px solid #d9d9d9; border-radius: 12px; font-weight: 500; font-size: 14px;">{{ each | comma }}</div>
                    </div>
                    <div style="margin-top: 20px">
                        <div style="display: flex; align-items: center; gap: 12px;">
                            <div style="margin-bottom: 0;" class="common_text">기존 수업 비용</div>
                            <div @click="setIsShowGuide">
                                <img style="width: 20px;" :src="require('@/assets/img/notice_feed.png')" alt="">
                            </div>
                        </div>
                        <div style="display: flex; align-items: center; gap: 12px; margin-top: 6px">
                            <input @keyup="comma2" class="class_fee" v-model="makeScheduleInfo.classCost" style="border-radius: 12px; width: 289px; border: 1px solid #d9d9d9; outline: none; padding: 12px;" placeholder="직접 입력" type="tel">
                            <div style="font-weight: 500; font-size: 14px">원</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!makeScheduleInfo.is_group_buying" style="margin-bottom: 16px; position:relative;">
                <div style="display: flex; align-items: center; gap: 6px;">
                    <div style="margin-bottom:0px;" class="common_text">트레이닝 비용</div><img :src="require('@/assets/img/team_training_info_icon.png')" style="width:20px; height:20px;">
                    <!-- <div @click="setIsShowGuide">
                        <img style="width: 20px;" :src="require('@/assets/img/notice_feed.png')" alt="">
                    </div> -->
                </div>
                <div style="display: flex; align-items: center; gap: 12px; margin-top: 6px">
                    <input @keyup="comma2" class="class_fee" v-model="makeScheduleInfo.classCost" style="border-radius: 12px; width: 289px; border: 1px solid #d9d9d9; outline: none; padding: 12px;" placeholder="직접 입력" type="tel">
                    <div style="font-weight: 500; font-size: 14px">원</div>
                </div>
                <!--<div style="display: flex; gap: 8px; margin-top: 8px;">-->
                    <!--<div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>-->
                    <!--<div style="line-height: 24px; font-size: 12px; font-weight: 500">추천 팀트레이닝 참여 비용</div>-->
                <!--</div>-->
                <div class="hide_scroll" style="display: flex; gap: 4px; overflow-x: scroll; margin: 0 -12px; padding: 0 12px; margin-top: 10px; ">
                    <div @click="setClassCost(each)" v-for="each, i in classDuesList" :key="i" style="line-height: 24px; flex-shrink: 0; padding: 4px; text-align: center; width: 93px; border: 1px solid #d9d9d9; border-radius: 12px; font-weight: 500; font-size: 14px;">{{ each | comma }}</div>
                </div>
                <!--<div v-if="isModify" style="position:absolute; left:0px; top:0px; width: calc(100% + 12px); height:100%; background-color: white; opacity: 0.7;"></div>-->
            </div>
            <!--<div v-if="isModify" style="font-size: 12px;font-weight: 500;line-height: 20px; margin-top:-12px; padding-bottom:10px;">비용은 수정할 수 없습니다</div>-->

            <div class="step3">
                <div class="common_text" :style="{ opacity: isModify ? '1.0' : '1.0' }">트레이닝 일정</div>
                <div class="schedule_box">
                    <div @click="showCalendar" class="select_day common">
                        <img :src="require('@/assets/img/make_sche_calendar.png')" alt="">
                        <div class="title">일정</div>
                        <div v-if="isShowDate" class="select_sche">{{ isModify ? $Util.getMMDDDayHangulStr(makeScheduleInfo.join_date) : settingJoinDate }}</div>
                        <div v-else-if="isShowRepeatDay" class="select_sche">{{ settingRepeatDay }}</div>
                        <div v-else class="select_sche">선택</div>
                        <div class="arrow_img_wrap">
                            <img :src="require('@/assets/images/mypage/ico-move.png')" alt="">
                        </div>
                    </div>

                    <div v-if="isModify && days && !isCopy" @click="() => {isOpenDateChangeCalendar = true}" class="select_day common">
                        <img :src="require('@/assets/img/make_sche_calendar.png')" alt="">
                        <div class="title">날짜</div>
                        <div class="select_sche">{{ $Util.getMMDDDayHangulStr(makeScheduleInfo.join_date) }}</div>
                        <div class="arrow_img_wrap">
                            <img :src="require('@/assets/images/mypage/ico-move.png')" alt="">
                        </div>
                    </div>

                    <div :style="{ paddingBottom: isJoin ? '8px' : '' }" class="time_picker common">
                        <img :src="require('@/assets/img/time_picker.png')" alt="">
                        <div class="title">시간</div>
                        <div class="time_box">
                            <div @click="showTimeSelector('begin')" :class="isAllDay ? 'disable_time_box' : 'select_time'">{{ makeScheduleInfo.schedule_hour_begin }}</div>
                            <div style="color: #808080">~</div>
                            <div @click="showTimeSelector('end')" :class="isAllDay ? 'disable_time_box' : 'select_time'">{{ makeScheduleInfo.schedule_hour_end }}</div>
                        </div>
                    </div>
                    <div v-if="isJoin" style="border-top: 1px solid #ebebeb; padding-top: 8px; display: flex; justify-content: end; align-items: center;">
                        <div style="font-weight: 500; font-size: 14px;">하루종일</div>
                        <CommonSwitch :switchClickEvent="setAllDay" :changeWidth="'60px'" :isOn="isAllDay"></CommonSwitch>
                    </div>
                </div>

                <!--<div style="font-size: 12px;font-weight: 500;line-height: 20px;">일정은 수정할 수 없습니다</div>-->
            </div>

            <div class="step4">
                <div class="common_text">장소</div>
                <div class="common_box">
                    <div v-if="isLoaded">
                        <NewPlaceSearchSelector v-if="!isModify" :isModify="isModify" :placeInfo="makeScheduleInfo.placeInfo" :resetInfo="resetInfo" :detect-select="detectRegionSelect" style="flex:1; "></NewPlaceSearchSelector>
                        <NewPlaceSearchSelector v-else :isModify="isModify" :placeInfo="makeScheduleInfo.placeInfo" :resetInfo="resetInfo" :detect-select="detectRegionSelect" style="flex:1; "></NewPlaceSearchSelector>
                    </div>
                </div>
            </div>
            <div v-if="!isJoin" class="step5">
                <div class="common_text">트레이닝 인원</div>
                <NewPlusMinusBtn :saveRecruit="saveRecruit" :isDuplicate="true" :duplicateCnt="isModify ? makeScheduleInfo.recruitCnt : 2" :minCnt="makeScheduleInfo.classType === '개인수업' ? 1 : 2" :maxCnt="makeScheduleInfo.classType === '개인수업' ? 10 : 30"></NewPlusMinusBtn>
            </div>

            <div class="step5">
                <div class="common_box">
                    <div style="display: flex;">
                        <div style="flex:1; padding-top:5px;">
                            <div style="font-weight:bold; font-size:14px; color:#210F03;">인원이 안 모여도 그대로 진행</div>
                            <div style="color:#210F03; font-size:12px; font-weight:500; line-height: 20px; margin-top:5px;">참여 인원이 다 모이지 않았어도 스케줄을 취소하지 않고 그대로 진행합니다.</div>
                        </div>
                        <div style="display:grid; place-items: center;">
                            <CustomSwitchFilter v-model="makeScheduleInfo.is_turn_off_auto_return" style="" :click-action="() => { }" :isBold="true" />
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 8px; margin-top: 8px">
                        <div style="height: 3px; width: 3px; background-color: #210f03; border-radius: 50%"></div>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px;">팀트레이닝 최소 참여 인원</div>
                    </div>
                    <div style="position:relative; display:inline-block;">
                        <NewPlusMinusBtn :btnBackground="'#fff'" :saveRecruit="setLeastCnt" :isDuplicate="true" :duplicateCnt="isModify ? makeScheduleInfo.leastCnt : 2" :maxCnt="30"></NewPlusMinusBtn>
                        <div v-if="!makeScheduleInfo.is_turn_off_auto_return" style="position:absolute; left:0px; top:0px; width:100%; height:100%; background-color: white; opacity: 0.7;"></div>
                    </div>

                </div>
            </div>

            <div v-if="!isJoin" class="step6">
                <div class="common_text">트레이닝 추천 연령대</div>
                <div style="display: flex; flex-wrap: wrap; gap: 12px;" class="hide_scroll">
                    <div @click="setRecommendAge(each)" :class="each === makeScheduleInfo.recommendAge ? 'active' : 'un_active'" v-for="each, i in recommendAgeList" :key="i" style="border-radius: 12px; padding: 12px 20px; flex-shrink: 0; font-weight: 500; font-size: 14px; line-height: 24px">{{ each }}</div>
                </div>
            </div>
            <div style="margin-top: 20px;" v-if="!isJoin" class="step6">
                <div class="common_text">성별</div>
                <div style="display: flex; flex-wrap: wrap; gap: 12px;" class="hide_scroll">
                    <div @click="setRecommendSex(each)" :class="each === makeScheduleInfo.sex ? 'active' : 'un_active'" v-for="each, i in sexList" :key="i" style="border-radius: 12px; padding: 12px 20px; flex-shrink: 0; font-weight: 500; font-size: 14px; line-height: 24px">{{ each }}</div>
                </div>
            </div>
            <div style="margin-top: 20px;" v-if="!isJoin" class="step6">
                <div class="common_text">수준</div>
                <div style="display: flex; flex-wrap: wrap; gap: 12px;" class="hide_scroll">
                    <div @click="setLevel(each)" :class="level_arr.indexOf(each) > -1 ? 'active' : 'un_active'" v-for="each, i in levelList" :key="i" style="border-radius: 12px; padding: 12px 20px; flex-shrink: 0; font-weight: 500; font-size: 14px; line-height: 24px">{{ each }}</div>
                </div>
            </div>
            <div style="margin-top: 20px;" v-if="!isJoin" class="step6">
                <div style="margin-bottom: 10px;" class="common_text">구장 사진</div>
                <div style="display: flex; gap: 12px; overflow-x: scroll; margin: 0 -12px; padding: 0 12px; align-items: center;" class="hide_scroll">
                    <div v-for="each, i in imgSrcArr" style="position: relative" :key="i">
                        <img style="width: 200px; height: 230px; object-fit: cover; border-radius: 12px" :src="each.src" alt="">
                        <div @click="deleteImg(i)" style="position:absolute; right:0px; bottom: 0px; padding:5px;">
                            <img :src="require('@/assets/img/rounded_trash_can.png')" style="width:30px; height:30px;">
                        </div>
                    </div>
                    <div @click="showFiles" style="">
                        <img :src="require('@/assets/img/soccerhow_write_album.png')" style="width:80px; height:80px; margin-bottom: 8px;">
                    </div>
                </div>
                <div style="font-size: 12px;font-weight: 500;">
                    <div style=" line-height: 20px;">팀트레이닝가 진행되는 구장의 사진을 최소 1장 업로드하세요<br>직접 찍은 사진이 없다면, 구장을 검색하고 이미지를 다운로드 후 업로드해주세요</div>
                </div>
                <div style="display:flex; align-items: center;">
                    <input type="file" style="display:none;" ref="file0" data-id="file0" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="file1" data-id="file1" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="file2" data-id="file2" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="file3" data-id="file3" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="file4" data-id="file4" @change="readURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                </div>
            </div>
            <div style="margin-top: 20px;" v-if="!isJoin" class="step6">
                <div style="margin-bottom: 10px;" class="common_text">슬라이드 사진</div>
                <div style="display: flex; gap: 12px; overflow-x: scroll; margin: 0 -12px; padding: 0 12px; align-items: center;" class="hide_scroll">
                    <div v-for="each, i in slideImgSrcArr" style="position: relative" :key="i">
                        <img style="width: 200px; height: 230px; object-fit: cover; border-radius: 12px" :src="each.src" alt="">
                        <div @click="deleteSlideImg(i)" style="position:absolute; right:0px; bottom: 0px; padding:5px;">
                            <img :src="require('@/assets/img/rounded_trash_can.png')" style="width:30px; height:30px;">
                        </div>
                    </div>
                    <div @click="showSlideFiles" style="">
                        <img :src="require('@/assets/img/soccerhow_write_album.png')" style="width:80px; height:80px; margin-bottom: 8px;">
                    </div>
                </div>
                <div style="font-size: 12px;font-weight: 500;">
                    <div style=" line-height: 20px;">팀트레이닝가 진행되는 구장의 사진을 최소 1장 업로드하세요<br>직접 찍은 사진이 없다면, 구장을 검색하고 이미지를 다운로드 후 업로드해주세요</div>
                </div>
                <div style="display:flex; align-items: center;">
                    <input type="file" style="display:none;" ref="slide_file0" data-id="slide_file0" @change="readSlideURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="slide_file1" data-id="slide_file1" @change="readSlideURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="slide_file2" data-id="slide_file2" @change="readSlideURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="slide_file3" data-id="slide_file3" @change="readSlideURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                    <input type="file" style="display:none;" ref="slide_file4" data-id="slide_file4" @change="readSlideURL($event)" :accept="$GlobalStore.loginInfo().grade_idx === '2' ? '' : 'image/*'">
                </div>
            </div>

            <div style="margin-top: 20px;" class="input_text contents">
                <div class="common_text">트레이닝 분위기</div>
                <textarea style="resize: none; line-height: 24px;" v-model="makeScheduleInfo.explanation1" placeholder="입력" class="text_area"></textarea>
            </div>
            <div style="margin-top: 20px;" class="input_text contents">
                <div class="common_text">주로 가르치는 내용 및 훈련 타겟</div>
                <textarea style="resize: none; line-height: 24px;" v-model="makeScheduleInfo.explanation2" placeholder="입력" class="text_area"></textarea>
            </div>


            <!--<div style="margin-top: 20px;" class="input_text contents">-->
            <!--<div class="common_text">팀트레이닝 팀원 특징 제목</div>-->
            <!--<textarea style="resize: none; line-height: 24px;" v-model="makeScheduleInfo.characteristic_title" placeholder="팀원 특징 제목" class="text_area" type="text"></textarea>-->
            <!--</div>-->
            <!--<div style="margin-top: 20px;" class="input_text contents">-->
            <!--<div class="common_text">팀트레이닝 팀원 특징 내용</div>-->
            <!--<textarea style="resize: none; line-height: 24px;" v-model="makeScheduleInfo.characteristic_desc" placeholder="팀원 특징 내용" class="text_area" type="text"></textarea>-->
            <!--</div>-->

            <!--<div style="margin-top: 20px;" class="input_text title">-->
            <!--<div class="common_text">우선순위(낮을수록 가장먼저 노출)</div>-->
            <!--<input v-model="repeat_schedule_seq" placeholder="숫자를 입력하세요." class="text_area" type="tel">-->
            <!--</div>-->

            <!--<div style="margin-top: 20px;" v-if="!isJoin" class="step6">-->
            <!--<div style="margin-bottom: 10px;" class="common_text">소개</div>-->
            <!--<div v-for="each, i in introduce" :key="i" class="margin_top">-->
            <!--<div v-if="each.type == JOIN_SCHEDULE_INTRODUCE_TYPE.TITLE" class="schedule_box">-->
            <!--<div>-->
            <!--<input type="text" v-model="each.title" placeholder="제목">-->
            <!--<input type="text" v-model="each.sub_title" placeholder="부제목" style="margin-top:5px;">-->
            <!--</div>-->
            <!--<div style="">-->
            <!--<div class="introduc_del_btn" @click="deleteIntroduceOne(i)">삭제</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div v-else-if="each.type == JOIN_SCHEDULE_INTRODUCE_TYPE.TEXT" class="schedule_box">-->
            <!--<textarea v-model="each.text" placeholder="내용" style=" border: 1px solid #ccc; border-radius: 4px; resize:none; width:100%; height:200px;"></textarea>-->
            <!--<div style="">-->
            <!--<div class="introduc_del_btn" @click="deleteIntroduceOne(i)">삭제</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div v-else-if="each.type == JOIN_SCHEDULE_INTRODUCE_TYPE.IMAGE" class="schedule_box">-->
            <!--<img style="width:100px;border:1px solid #ccc" :src="each.image_path ? $resourcePath + each.image_path : require('@/assets/img/soccerhow_write_album.png')" :ref="'introduce_image_' + i" @click="() => {$refs['introduce_image_file' + i][0].click();}">-->
            <!--<input type="file" style="display:none;" :ref="'introduce_image_file' + i" @change="readIntroduceImageUrl($event, 'introduce_image_' + i)">-->
            <!--<div style="">-->
            <!--<div class="introduc_del_btn" @click="deleteIntroduceOne(i)">삭제</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div style="display:flex; margin-top:10px;">-->
            <!--<div @click="addIntroduceTitle" style="flex:1; border-radius:8px; display:grid; place-items: center;" class="add_btn">제목</div>-->
            <!--<div @click="addIntroduceText" style="flex:1; border-radius:8px; display:grid; place-items: center;" class="add_btn">내용</div>-->
            <!--<div @click="addIntroduceImage" style="flex:1; border-radius:8px; display:grid; place-items: center;" class="add_btn">이미지</div>-->
            <!--</div>-->
            <!--</div>-->

        </div>
        <div class="make_schedule_wrap" style="display:flex; gap : 10px; padding:10px 10px;">
            <div v-if="isModify && days && !isCopy" class="make_schedule" style="flex:1;background-color:#c96eec" @click="saveTargetDate">이번주만 수정하기</div>
            <div v-if="isModify" @click="makeSchedule" class="make_schedule" style="flex:1;">{{isCopy ? '복사하기' : (days ? '전체수정하기' : '수정하기')}}</div>
            <div v-else-if="isJoin" @click="makeMemberTalkSchedule" class="make_schedule" style="flex:1;"></div>
            <div v-else :class="isWriteAll ? 'active_btn' : 'un_active_btn'" @click="makeSchedule" class="make_schedule" style="flex:1;">스케줄 만들기</div>
        </div>
        <div style="position: relative; z-index: 100;">
            <TimeSelectorPopupNew :is-show-time-selector="isShowTimeSelectorBegin" :hide="() => { isShowTimeSelectorBegin = false }" :start-time="makeScheduleInfo.schedule_hour_begin" :complete-action="setTimeBegin"></TimeSelectorPopupNew>
        </div>
        <div style="position: relative; z-index: 100;">
            <TimeSelectorPopupNew :is-show-time-selector="isShowTimeSelectorEnd" :hide="() => { isShowTimeSelectorEnd = false }" :start-time="makeScheduleInfo.schedule_hour_end" :complete-action="setTimeEnd"></TimeSelectorPopupNew>
        </div>
        <div style="position: relative; z-index: 100;" v-if="isLoaded">
            <ScheduleSettings :isJoin="isJoin" :joinDate="saveJoinDate" :isRepeat="(!isCopy && (this.days && this.days.length > 0) ? true : false)" :isModify="isModify" :repeatDay="repeatDay" :resetRepeatDay="resetRepeatDay" :setRepeatDay="setRepeatDay" :resetJoinDate="resetJoinDate" :detectSelectDate="detectSelectDate" :isOpenCalendar="isOpenCalendar" :closeCalendar="closeCalendar"></ScheduleSettings>
        </div>

        <div style="position: relative; z-index: 100;" v-if="isRepeat && !isCopy && isLoaded">
            <ScheduleSettings :isJoin="false" :joinDate="saveJoinDate" :isRepeat="false" :isModify="true" :repeatDay="''" :detectSelectDate="detectChangeDate" :isOpenCalendar="isOpenDateChangeCalendar" :closeCalendar="() => {isOpenDateChangeCalendar = false}"></ScheduleSettings>
        </div>

        <EditModalFrame :isOpen="isShowGroupClassModal" :noTitle="true" :closeModal="closeGroupClassModal">
            <div style="text-align: center; position: relative; padding: 8px 0;">
                <div @click="closeGroupClassModal" style="position: absolute; left: 0">
                    <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
                </div>
                <div>
                    <img style="width: 60px;" :src="require('@/assets/img/group_class_title.png')" alt="">
                </div>
                <div style="margin: 16px 0;">
                    <div style="font-weight: 700; line-height: 24px; margin-bottom: 8px">저렴한 금액으로 수업을 받고 싶은 회원들이 많습니다 회원들에게 수업 공동구매 기회를 제공하세요</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px">그룹스케줄은 저렴한 금액으로 수업을 제공하지만<br>다양한 회원들을 모을 수 있는 좋은 방법입니다.<br>지금 단체수업 공동구매 기회를 제공해보세요</div>
                </div>
                <div @click="setClassType('공동구매 수업', true)" style="border: 1px solid #210f03; border-radius: 12px; padding: 12px; line-height: 24px; font-weight: 500; font-size: 14px;">공동구매 단체수업 만들기</div>
            </div>
        </EditModalFrame>
        <EditModalFrame :isOpen="isShowGuide" :title="'수업 비용 가이드라인'" :closeModal="closeGuide">
            <div style="position: relative; padding: 20px 0;">
                <div style="margin-bottom: 30px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">1. 수업 종류에 따른 평균 수업 비용</div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">개인수업은 연령대와 실력에 상관없이 1회 최소 <span style="font-weight: 700">60,000</span>원 ~ 최대 <span style="font-weight: 700">120,000</span>원입니다.</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">단체수업은 다양하게 진행되기 때문에 최소 및 최대 금액만 산정해볼 수 있습니다. 통상적으로 1회 최소 <span style="font-weight: 700">20,000</span>원 ~ 최대 <span style="font-weight: 700">60,000</span>원으로 진행되고 있습니다.</div>
                    </div>
                </div>
                <div style="margin-bottom: 30px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">2. 구장 보유 여부에 따른 수업 비용</div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">수업을 진행하기 위해서는 수업할 구장이 있어야 합니다.</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">구장을 대관해서 수업을 진행해야 할 경우 구장 대관비를 부담해야 하므로 수업료를 올려 진행하는 것을 권장합니다.</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">축구교실 소속 코치이거나 구장을 보유하고 있는 경우 구장 대관비를 부담하지 않아도 되므로 통상적인 수업료로 수업을 진행하는 것을 권장합니다.</div>
                    </div>
                </div>
                <div style="">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">3. 수업 경험 및 실력 따른 수업 비용</div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">수업을 진행해본 경험이 없을 경우에는 최소 수업 비용으로 수업을 진행하는 것을 권장합니다.</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">다양한 코칭 경험이 있을 경우 최대 수업 비용을 받는 것도 권장합니다.</div>
                    </div>
                </div>
            </div>
            <div @click="closeGuide" style="padding: 12px; background-color: #f5f5f5; border-radius: 12px; text-align: center; font-weight: 700; font-size: 14px; line-height: 24px;">확인</div>
        </EditModalFrame>
        <!--<CommonPopupFrame :changeHeight="100" :changeBottom="0" :isOpen="isOpenNowStart" :closeCompleteAction="closeNowStart">-->
        <!--<div @touchmove.stop="() => { }" @click="closeAll" style="padding:0px 7px; margin-top: 16px; position: relative; z-index: 3;">-->
        <!--<img style="width: 42px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />-->
        <!--</div>-->
        <!--<div @touchmove.stop="() => { }">-->
        <!--<img style="width: 100%; position: absolute; top: 0; right: 0; height: 100%; z-index: 1;" :src="require('@/assets/img/now_back.png')" alt="">-->
        <!--<img style="width: 194px; position: absolute; z-index: 2; top: 50%; left: 50%; transform: translate(-45%, -50%);" :src="require('@/assets/img/now_logo_white.png')" alt="">-->
        <!--</div>-->
        <!--<div style="position: relative; z-index: 3; flex: 1; position: absolute; bottom: 54px; padding: 0 12px; text-align: center;">-->
        <!--<div style="font-weight: 700; line-height: 24px; text-shadow: 0px 1px 6px rgba(0, 0, 0, 1.0); color: #fff;">합리적인 금액으로 코칭을 받고 싶어하는 회원들이 많습니다 나우를 통해 회원들에게 합리적인 코칭 기회를 제공하세요!</div>-->
        <!--<div style="margin-top: 16px; margin-bottom: 31px; text-shadow: 0px 1px 6px rgba(0, 0, 0, 1.0); color: #fff; line-height: 24px; font-size: 14px;">나우는 저렴한 금액으로 코칭과 매치 기회를 제공하면서<br>다양한 회원들을 모집할 수 있는 좋은 방법입니다</div>-->
        <!--<div @click="closeNowStart" style="width: 342px; height: 48px; line-height: 48px; border-radius: 12px; text-align: center; background-color: #fff; font-size: 14px; font-weight: 500; margin: 0 auto;">나우 스케줄 만들기</div>-->
        <!--</div>-->
        <!--</CommonPopupFrame>-->
    </div>
</template>

<script>
    import moment from 'moment';
    // import MercenaryModalBtn from '@/components/common/MercenaryModalBtn';
    import NewPlaceSearchSelector from '@/components/common/NewPlaceSearchSelector';
    import NewPlusMinusBtn from '@/components/common/NewPlusMinusBtn';
    import TimeSelectorPopupNew from '@/components/common/TimeSelectorPopupNew';
    // import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
    import ScheduleSettings from '@/components/mercenary/ScheduleSettings';
    import ResponseCode from '@/ResponseCode';
    import { MEMBER_TYPE, DUES_TYPE } from '@/Constants';
    import CommonSwitch from '@/components/common/CommonSwitch';
    import EditModalFrame from '@/components/modal/my/EditModalFrame';
    import CustomSwitchFilter from "../../common/CustomSwitchFilter";
    import {JOIN_SCHEDULE_INTRODUCE_TYPE} from "../../../Constants";
    import MercenaryHeader from "../../common/MercenaryHeader";
    // import CustomSwitchFilter from '@/components/common/CustomSwitchFilter'

    export const MAKE_SCHEDULE_MODE = {
        DEFAULT: 0,
        POPUP: 1,
    };

    export default {
        components: {
            MercenaryHeader, CustomSwitchFilter,
            // CommonPopupFrame,
            NewPlaceSearchSelector, NewPlusMinusBtn, TimeSelectorPopupNew, ScheduleSettings, CommonSwitch, EditModalFrame },
        name: "MakeClassScheduleFeed",
        props: {
            closeCompleteAction: {
                type: Function,
                default: () => {}
            },
            scheduleIdx: {
                type: [String, Number],
                default: ''
            },
            completeAction: {
                type: Function,
                default: () => { }
            },
            isJoin: {
                type: Boolean,
                default: false
            },
            joinIdx: {
                type: [String, Number],
                default: ''
            },
            isModifyMemberTalkSchedule: {
                type: Boolean,
                default: false
            },
            isOpen: {
                type: Boolean,
                default: false
            },
            mode: {
                type: Number,
                default: 0
            },
            isCopy : {
                type : Boolean,
                default : false
            }
        },
        computed: {
            settingJoinDate() {
                let transJoinDate;

                transJoinDate = this.makeScheduleInfo.join_date.split('-')[0] + '년 ' + this.makeScheduleInfo.join_date.split('-')[1] + '월 ' + this.makeScheduleInfo.join_date.split('-')[2] + '일 ' + this.dayOfWeek + '요일'

                return transJoinDate
            },
            settingRepeatDay() {
                let transRepeatDay

                transRepeatDay = '매주 ' + this.repeatDay.join(', ')

                return transRepeatDay
            },
            isWriteAll() {
                if (this.makeScheduleInfo.title === '') {
                    return false
                }

                if (this.makeScheduleInfo.contents === '') {
                    return false
                }

                if (this.makeScheduleInfo.classType === '') {
                    return false
                }

                if (this.makeScheduleInfo.classCost === '') {
                    return false
                }

                if (this.makeScheduleInfo.join_date === '' && this.repeatDay.length === 0) {
                    return false
                }

                if (this.makeScheduleInfo.schedule_hour_begin === '' || this.makeScheduleInfo.schedule_hour_end === '') {
                    return false
                }

                if (Object.keys(this.makeScheduleInfo.placeInfo).length === 0) {
                    return false
                }

                if (this.makeScheduleInfo.is_group_buying === true && this.makeScheduleInfo.groupClassCost === '') {
                    return false
                }

                if (this.makeScheduleInfo.recommendAge === '') {
                    return false
                }

                if (this.makeScheduleInfo.sex === '') {
                    return false
                }

                if (this.makeScheduleInfo.level === '') {
                    return false
                }

                return true
            }
        },
        data() {
            return {
                JOIN_SCHEDULE_INTRODUCE_TYPE : JOIN_SCHEDULE_INTRODUCE_TYPE,
                sexList: [ '혼성', '남성', '여성'],
                classType: ['개인수업', '단체수업', '공동구매 수업'],
                // recommendAgeList: ['10대', '20대', '30대', '40대', '40대 이상', '무관'],
                recommendAgeList: ['성인'],
                classDuesList: ['10,000', '20,000', '30,000', '40,000', '50,000'],
                levelList : ['초급', '중급', '상급'],
                recommendClassDuesList: ['15,000', '18,000', '20,000'],
                DUES_TYPE: DUES_TYPE,
                MAKE_SCHEDULE_MODE: MAKE_SCHEDULE_MODE,
                makeScheduleInfo: {
                    title: '',
                    contents: '',
                    classType: '나우',
                    placeInfo: {},
                    recruitCnt: '2',
                    schedule_hour_begin: '',
                    schedule_hour_end: '',
                    join_date: '',
                    is_group_buying: false,
                    classCost: '',
                    groupClassCost: '',
                    recommendAge: '',
                    sex: '',
                    level : '',
                    explanation1 : '',
                    explanation2 : '',
                    is_turn_off_auto_return: false,
                    leastCnt: '2',
                    characteristic_title: '',
                    characteristic_desc: '',
                },
                isShowGroupClassModal: false,
                isShowTimeSelectorBegin: false,
                isShowTimeSelectorEnd: false,
                isOpenCalendar: false,
                isShowDate: false,
                isShowRepeatDay: false,
                dayOfWeek: '',
                repeatDay: [],
                days : '',
                MEMBER_TYPE: MEMBER_TYPE,
                isModify: false,
                modifyCnt: 0,
                isDataLoaded: false,
                saveJoinDate: '',
                isShowPopup: false,
                isAllDay: false,
                isShowGuide: false,
                isOpenNowStart: false,
                scheduleDetail: {},
                isLoaded: false,
                repeatSchedule: {},
                isRepeat: false,
                imgSrcArr: [],
                slideImgSrcArr: [],
                creator_idx : -1,
                creator_name : '',
                introduce : [],
                isOpenDateChangeCalendar : false,
                isDateChange : false,
                repeat_schedule_seq : 10,
                level_arr : [],
            }
        },
        methods: {
            saveTargetDate(){
                this.isDateChange = true;
                this.makeSchedule();
            },
            detectChangeDate(changeDate){
                this.makeScheduleInfo.join_date = changeDate
            },
            deleteIntroduceOne(i){
                this.introduce.splice(i, 1);
            },
            addIntroduceTitle(){
                this.introduce.push({
                    type : JOIN_SCHEDULE_INTRODUCE_TYPE.TITLE,
                    title : '',
                    sub_title : '',
                })
            },
            addIntroduceText(){
                this.introduce.push({
                    type : JOIN_SCHEDULE_INTRODUCE_TYPE.TEXT,
                    text : '',
                })
            },
            addIntroduceImage(){
                this.introduce.push({
                    type : JOIN_SCHEDULE_INTRODUCE_TYPE.IMAGE,
                    image_path : '',
                });

                setTimeout(() => {
                    this.$refs['introduce_image_file' + (this.introduce.length - 1)][0].click();
                }, 100)

                this.$nextTick(() => {

                })
            },
            deleteSlideImg(index) {
                this.$refs[this.slideImgSrcArr[index].id].value = '';
                this.$delete(this.slideImgSrcArr, index);
            },
            deleteImg(index) {
                this.$refs[this.imgSrcArr[index].id].value = '';
                this.$delete(this.imgSrcArr, index);
            },
            showSlideFiles() {
                if (this.slideImgSrcArr.length >= 5) {
                    alert('최대 5개까지 업로드 가능합니다.');
                    return;
                }

                for (let i = 0; i < 5; i++) {
                    if (this.$refs['slide_file' + i].value === '') {
                        this.$refs['slide_file' + i].click();
                        return;
                    }
                }
            },
            showFiles() {
                if (this.imgSrcArr.length >= 5) {
                    alert('최대 5개까지 업로드 가능합니다.');
                    return;
                }

                for (let i = 0; i < 5; i++) {
                    if (this.$refs['file' + i].value === '') {
                        this.$refs['file' + i].click();
                        return;
                    }
                }
            },
            readIntroduceImageUrl(e, ref) {
                const input = e.currentTarget;

                if (input.files && input.files[0]) {
                    var extension = input.files[0].name.split('.').pop().toLowerCase();

                    if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp') {

                        var reader = new FileReader();
                        reader.onload = (e) => {
                            if (input.files[0].size > 1024 * 1024 * 1024) {
                                input.files[0].value = '';
                                this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                                return;
                            }

                            this.$refs[ref][0].src = e.target.result
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                    }
                }
            },
            readSlideURL(e) {
                const input = e.currentTarget;

                if (input.files && input.files[0]) {
                    var extension = input.files[0].name.split('.').pop().toLowerCase();

                    if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp') {

                        var reader = new FileReader();
                        reader.onload = (e) => {
                            if (input.files[0].size > 1024 * 1024 * 1024) {
                                input.files[0].value = '';
                                this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                                return;
                            }

                            const data = { src: e.target.result, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                            if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.src = require('@/assets/this_is_video.png');
                            this.slideImgSrcArr = [...this.slideImgSrcArr, data];
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                    }
                }
            },
            readURL(e) {
                const input = e.currentTarget;

                if (input.files && input.files[0]) {
                    var extension = input.files[0].name.split('.').pop().toLowerCase();

                    if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp') {

                        var reader = new FileReader();
                        reader.onload = (e) => {
                            if (input.files[0].size > 1024 * 1024 * 1024) {
                                input.files[0].value = '';
                                this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                                return;
                            }

                            const data = { src: e.target.result, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                            if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.src = require('@/assets/this_is_video.png');
                            this.imgSrcArr = [...this.imgSrcArr, data];
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                    }
                }
            },
            setLeastCnt(leastCnt) {
                this.makeScheduleInfo.leastCnt = leastCnt
            },
            transNumberToDay(days) {
                // const dayNumbers = [0, 1, 2, 3, 4, 5, 6];
                console.log(days)
                const daysOfWeek = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
                const saveDays = days

                const transNumberToDay = saveDays.split(',').map(saveDays => daysOfWeek[saveDays])

                return transNumberToDay
            },
            async getScheduleDetail() {
                const parameters = {}
                parameters.join_schedule_idx = this.scheduleIdx;
                parameters.is_visit = true;
                const res = await this.$Axios.get('/api/join/schedule/detail', { params: parameters });
                const scheduleDetail = res.data.join_schedules
                const groundImage = res.data.join_schedule_images ?? []
                const slideImage = res.data.join_schedule_slider_images ?? []

                for (let i = 0; i < 5; i++) {
                    if (groundImage['image_path' + i]) {
                        this.imgSrcArr.push({ src: this.$resourcePath + groundImage['image_path' + i], id: 'file' + i, path: groundImage['image_path' + i], thumPath: groundImage['thumb_image_path' + i], isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 })
                    }
                }

                for (let i = 0; i < 5; i++) {
                    if (slideImage[i]) {
                        this.slideImgSrcArr.push({ src: this.$resourcePath + slideImage[i].image_path, id:'slide_file' + i, path: slideImage[i].image_path, thumPath: slideImage[i].thumb_image_path, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 })
                    }
                }
                this.introduce = (res.data.join_schedule_introduce ? res.data.join_schedule_introduce.introduce ?? [] : []);
                if(this.introduce.length > 0){
                    for(const each of this.introduce){
                        if(each.type == JOIN_SCHEDULE_INTRODUCE_TYPE.TEXT){
                            each.text = each.text.replaceAll('@%n', '\n')
                        }
                    }
                }

                const repeat_schedule =  res.data.repeat_schedule
                this.scheduleDetail = scheduleDetail
                this.repeatSchedule = res.data.repeat_schedule
                this.creator_idx = scheduleDetail.creator_idx;
                this.creator_name = scheduleDetail.creator.nic_name;

                if (this.repeatSchedule) {
                    this.isShowRepeatDay = true
                    this.isRepeat = true
                    this.repeatDay = this.transNumberToDay(this.repeatSchedule.days)
                    this.days = repeat_schedule.days;
                    if(this.days === '') this.isShowDate = true;
                } else {
                    this.isShowDate = true
                }

                this.repeat_schedule_seq = repeat_schedule.seq;

                this.makeScheduleInfo.title = this.scheduleDetail.title
                this.makeScheduleInfo.contents = this.scheduleDetail.contents
                this.makeScheduleInfo.classCost = this.$options.filters.comma(this.scheduleDetail.dues_group);
                this.makeScheduleInfo.join_date = this.scheduleDetail.join_date
                this.makeScheduleInfo.schedule_hour_begin = this.scheduleDetail.join_begin_date_time.split(' ')[1].split('.')[0].substring(0, 5)
                this.makeScheduleInfo.schedule_hour_end = this.scheduleDetail.join_end_date_time.split(' ')[1].split('.')[0].substring(0, 5)
                this.makeScheduleInfo.recruitCnt = this.scheduleDetail.max_cnt - 1
                this.makeScheduleInfo.recommendAge = this.scheduleDetail.recommend_age
                this.makeScheduleInfo.sex = this.scheduleDetail.sex
                this.makeScheduleInfo.level = this.scheduleDetail.level ? this.scheduleDetail.level : '';
                this.level_arr = this.scheduleDetail.level ? this.scheduleDetail.level.split(', ') : [];
                this.makeScheduleInfo.explanation1 = this.scheduleDetail.explanation1 ? this.scheduleDetail.explanation1 : '';
                this.makeScheduleInfo.explanation2 = this.scheduleDetail.explanation2 ? this.scheduleDetail.explanation2 : '';
                this.makeScheduleInfo.is_turn_off_auto_return = this.scheduleDetail.is_refund_auto != '1';
                this.makeScheduleInfo.leastCnt = this.scheduleDetail.min_cancel_cnt - 1;
                this.makeScheduleInfo.characteristic_title = repeat_schedule.characteristic_title ? repeat_schedule.characteristic_title : '';
                this.makeScheduleInfo.characteristic_desc = repeat_schedule.characteristic_desc ? repeat_schedule.characteristic_desc : '';
                this.makeScheduleInfo.placeInfo = {
                    name: this.scheduleDetail.place_name,
                    id: this.scheduleDetail.place_id,
                    gps_latitude: this.scheduleDetail.gps_latitude,
                    gps_longitude: this.scheduleDetail.gps_longitude,
                    address: this.scheduleDetail.address,
                }

                this.isLoaded = true;

            },
            closeAll() {
                this.isOpenNowStart = false;
                this.completeAction()
            },
            closeNowStart() {
                this.isOpenNowStart = false;
            },
            setIsShowGuide() {
                this.isShowGuide = true
            },
            closeGuide() {
                this.isShowGuide = false
            },
            closeGroupClassModal() {
                this.isShowGroupClassModal = false
            },
            setRecommendAge(age) {
                this.makeScheduleInfo.recommendAge = age
            },
            setLevel(level){
                const indexOf = this.level_arr.indexOf(level)
                if(indexOf > -1){
                    this.level_arr.splice(indexOf, 1);
                } else {
                    this.level_arr.push(level);
                }

                const new_level_arr = [];
                for(const each of this.levelList){
                    for(const each2 of this.level_arr){
                        if(each === each2){
                            new_level_arr.push(each2);
                            break;
                        }
                    }
                }

                this.level_arr = new_level_arr;
                this.makeScheduleInfo.level = this.level_arr.join(', ')//level
            },
            setRecommendSex(sex) {
                this.makeScheduleInfo.sex = sex
            },
            setGroupClassCost(cost) {
                this.makeScheduleInfo.groupClassCost = cost
            },
            setClassCost(cost) {
                this.makeScheduleInfo.classCost = cost
            },
            setIsGroupBuying() {
                this.makeScheduleInfo.is_group_buying = !this.makeScheduleInfo.is_group_buying
            },
            setAllDay() {
                this.isAllDay = !this.isAllDay
                if (this.isAllDay) {
                    this.makeScheduleInfo.schedule_hour_begin = '00:00'
                    this.makeScheduleInfo.schedule_hour_end = '23:59'
                } else {
                    this.makeScheduleInfo.schedule_hour_begin = ''
                    this.makeScheduleInfo.schedule_hour_end = ''
                }
            },
            handleIntroLength() {
                if (this.makeScheduleInfo.contents.length > 200) {
                    this.makeScheduleInfo.contents = this.makeScheduleInfo.contents.slice(0, 200)
                }
            },
            handleTitleLength() {
                if (this.makeScheduleInfo.title.length > 30) {
                    this.makeScheduleInfo.title = this.makeScheduleInfo.title.slice(0, 30)
                }
            },
            selectMatchType(match) {
                this.makeScheduleInfo.game_type = match
            },
            closePopup() {
                this.isShowPopup = false
            },
            resetInfo() {
                this.makeScheduleInfo.placeInfo = {}
            },
            resetRepeatDay() {
                this.isShowRepeatDay = false
                this.repeatDay = [];
                this.days = null;
            },
            setRepeatDay(day) {
                if (this.repeatDay.includes(day)) {
                    this.repeatDay = this.repeatDay.filter(item => item !== day)
                } else {
                    this.repeatDay.push(day)
                }
                this.days = this.transDays();
                // this.days =
                this.isShowRepeatDay = true
            },
            resetJoinDate() {
                this.makeScheduleInfo.join_date = ''
                this.isShowDate = false
            },
            detectSelectDate(date, day_str) {
                this.dayOfWeek = day_str
                this.makeScheduleInfo.join_date = date
                this.isShowDate = true
            },
            closeCalendar() {
                this.isOpenCalendar = false
            },
            showCalendar() {
                // if (this.isModify && this.repeatDay.length === 0) {
                //     return
                // }
                this.isOpenCalendar = true
            },
            showTimeSelector(type) {
                // if (this.isModify) {
                //     return
                // }
                if (type === 'begin') {
                    this.isShowTimeSelectorBegin = true
                } else {
                    this.isShowTimeSelectorEnd = true
                }
            },
            setTimeBegin(startHour) {
                this.makeScheduleInfo.schedule_hour_begin = startHour
                const end_time = moment(startHour, 'HH:mm').add(1, 'hours').format('HH:mm')
                this.makeScheduleInfo.schedule_hour_end = end_time
                // this.calcTimeTaken()
            },
            setTimeEnd(endHour) {
                this.makeScheduleInfo.schedule_hour_end = endHour
                // this.calcTimeTaken()
            },
            checkMakeSchedule() {
                if (this.makeScheduleInfo.title === '') {
                    this.$GlobalStore.showAlert('제목을 입력해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.contents === '') {
                    this.$GlobalStore.showAlert('소개를 입력해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.classType === '') {
                    this.$GlobalStore.showAlert('수업 유형을 선택해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.classCost === '') {
                    this.$GlobalStore.showAlert('수업 비용을 입력해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.join_date === '' && this.repeatDay.length === 0) {
                    this.$GlobalStore.showAlert('일정을 선택해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.schedule_hour_begin === '' || this.makeScheduleInfo.schedule_hour_end === '') {
                    this.$GlobalStore.showAlert('시간을 설정해주세요.')
                    return false
                }

                if (Object.keys(this.makeScheduleInfo.placeInfo).length === 0) {
                    this.$GlobalStore.showAlert('장소를 설정해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.is_group_buying === true && this.makeScheduleInfo.groupClassCost === '') {
                    this.$GlobalStore.showAlert('공동구매 수업 비용을 설정해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.recommendAge === '') {
                    this.$GlobalStore.showAlert('수업 추천 연령대를 선택해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.sex === '') {
                    this.$GlobalStore.showAlert('성별을 선택해주세요.')
                    return false
                }

                if (this.makeScheduleInfo.level === '') {
                    this.$GlobalStore.showAlert('수준을 선택해주세요.')
                    return false
                }

                if (this.imgSrcArr.length === 0) {
                    this.$GlobalStore.showAlert('구장 사진을 최소 1장 이상 등록해주세요.')
                    return false
                }

                return true
            },
            createFormData() {
                const formData = new FormData()

                formData.append('title', this.makeScheduleInfo.title)
                formData.append('contents', this.makeScheduleInfo.contents)
                formData.append('theme', this.makeScheduleInfo.classType)
                formData.append('join_date', this.makeScheduleInfo.join_date)
                formData.append('begin_time', this.makeScheduleInfo.schedule_hour_begin)
                formData.append('end_time', this.makeScheduleInfo.schedule_hour_end)
                formData.append('place_name', this.makeScheduleInfo.placeInfo.name);
                formData.append('place_id', this.makeScheduleInfo.placeInfo.id);
                formData.append('gps_latitude', this.makeScheduleInfo.placeInfo.gps_latitude);
                formData.append('gps_longitude', this.makeScheduleInfo.placeInfo.gps_longitude);
                formData.append('place_address', this.makeScheduleInfo.placeInfo.address);
                formData.append('sex', this.makeScheduleInfo.sex);
                formData.append('level', this.makeScheduleInfo.level);
                formData.append('explanation1', this.makeScheduleInfo.explanation1);
                formData.append('explanation2', this.makeScheduleInfo.explanation2);
                formData.append('dues', this.makeScheduleInfo.classCost)
                formData.append('mode', this.isModify ? 'update' : 'insert')
                formData.append('max_cnt', parseInt(this.makeScheduleInfo.recruitCnt) + 1)
                formData.append('recommend_age', this.makeScheduleInfo.recommendAge)
                formData.append('dues_group', this.makeScheduleInfo.classCost)
                formData.append('is_refund_auto', this.makeScheduleInfo.is_turn_off_auto_return ? '0' : '1');
                formData.append('min_cancel_cnt', this.makeScheduleInfo.is_turn_off_auto_return ? (parseInt(this.makeScheduleInfo.leastCnt) + 1) : (parseInt(this.makeScheduleInfo.recruitCnt) + 1));
                formData.append('member_idx', this.creator_idx);
                formData.append('isCopy', this.isCopy);
                formData.append('isDateChange', this.isDateChange);
                formData.append('characteristic_title', this.makeScheduleInfo.characteristic_title);
                formData.append('characteristic_desc', this.makeScheduleInfo.characteristic_desc);
                formData.append('repeat_schedule_seq', this.repeat_schedule_seq);

                for (let i = 0; i < this.slideImgSrcArr.length; i++) {
                    const curImgSrc = this.slideImgSrcArr[i];
                    if (curImgSrc.isFileTag && this.$refs[curImgSrc.id].value !== '') {
                        formData.append('slider_image_file' + i, this.$refs[curImgSrc.id].files[0]);
                    } else if (!curImgSrc.isFileTag) {
                        formData.append('slider_image_path' + i, curImgSrc.path)
                        formData.append('slider_thumb_image_path' + i, curImgSrc.thumPath)
                    }
                }

                for (let i = 0; i < this.imgSrcArr.length; i++) {
                    const curImgSrc = this.imgSrcArr[i];
                    if (curImgSrc.isFileTag && this.$refs[curImgSrc.id].value !== '') {
                        formData.append('image_file' + i, this.$refs[curImgSrc.id].files[0]);
                    } else if (!curImgSrc.isFileTag) {
                        formData.append('image_path' + i, curImgSrc.path)
                        formData.append('thumb_image_path' + i, curImgSrc.thumPath)
                    }
                }

                //소개
                let new_file_index = 0;
                for(let i = 0; i < this.introduce.length ; i++){
                    if(this.introduce[i].type != JOIN_SCHEDULE_INTRODUCE_TYPE.IMAGE) continue;
                    if(this.$refs['introduce_image_file' + i][0].value !== ''){
                        formData.append('introduce_image_file' + new_file_index, this.$refs['introduce_image_file' + i][0].files[0]);
                        this.introduce[i].introduce_image_file_key = 'introduce_image_path' + new_file_index;
                        new_file_index++;
                    }
                }

                formData.append('introduce', JSON.stringify(this.introduce));

                if (this.repeatDay.length !== 0) {
                    formData.append('days', this.days)
                }

                if (this.isModify) {
                    if(!this.isCopy) formData.append('join_schedule_idx', this.scheduleIdx)
                    if (this.repeatSchedule) {
                        formData.append('repeat_schedule_idx', this.repeatSchedule.idx)
                    }
                }

                return formData
            },
            async makeSchedule() {
                if (!this.checkMakeSchedule()) {
                    return
                }
                this.$GlobalStore.showProgress()

                const formData = this.createFormData()

                const res = await this.$Axios.post('/api/join/schedule/lesson/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.closeLastModal();
                    this.completeAction(true, res.data.join_schedule_idx)
                    this.$GlobalStore.hideProgress()
                } else {
                    this.$GlobalStore.showAlert(res.data.message)
                    this.$GlobalStore.hideProgress()
                }
            },
            saveRecruit(cnt) {
                this.makeScheduleInfo.recruitCnt = cnt
            },
            close() {
                if (this.isModify || this.isModifyMemberTalkSchedule) {
                    const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">작성 중인 내용이 모두 사라집니다.<br>트레이닝 수정을 중단하고 뒤로갈까요?</div>`;
                    this.$GlobalStore.showConfirm(html, async () => {
                        this.completeAction()
                    }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })

                    // this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block; width:280px;">스케줄 수정하기를 종료하시겠습니까?</strong><br>작성하던 내용은 저장되지 않습니다.<br>그래도 종료하시겠습니까?', () => {
                    //     this.completeAction()
                    // }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
                } else if (this.isJoin || this.isOpen) {
                    const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">작성 중인 내용이 모두 사라집니다.<br>트레이닝 만들기를 중단하고 뒤로갈까요?</div>`;
                    this.$GlobalStore.showConfirm(html, async () => {
                        if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                            this.$GlobalStore.closeLastModal()
                        } else {
                            this.completeAction()
                        }
                    }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })

                    // this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block; width:280px;">스케줄 만들기를 종료하시겠습니까?</strong><br>작성하던 내용은 저장되지 않습니다.<br>그래도 종료하시겠습니까?', () => {
                    //     if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                    //         this.$GlobalStore.closeLastModal()
                    //     } else {
                    //         this.completeAction()
                    //     }
                    // }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
                } else {
                    const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">작성 중인 내용이 모두 사라집니다.<br>트레이닝 만들기를 중단하고 뒤로갈까요?</div>`;
                    this.$GlobalStore.showConfirm(html, async () => {
                        if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                            this.$GlobalStore.closeSpliceModal('MakeJoinOrSchedule')
                        } else {
                            this.completeAction()
                        }
                    }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })

                    // this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">스케줄 만들기를 종료하시겠습니까?</strong><br>작성하던 내용은 저장되지 않습니다.<br>그래도 종료하시겠습니까?', () => {
                    //     if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                    //         this.$GlobalStore.closeSpliceModal('MakeJoinOrSchedule')
                    //     } else {
                    //         this.completeAction()
                    //     }
                    // }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
                }

            },
            transDays() {
                const dayNumbers = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];

                const transDays = this.repeatDay.map(day => dayNumbers.indexOf(day))

                return transDays.sort().join(',')
            },
            getDayOfWeeks(date) {
                const dateString = date
                const dateMoment = moment(dateString, 'YYYY-MM-DD')
                const weekday = dateMoment.format('dddd')

                return weekday[0]
            },
            setClassType(classType, isClickModal) {
                this.makeScheduleInfo.classCost = ''
                this.makeScheduleInfo.groupClassCost = ''
                if (isClickModal) {
                    this.makeScheduleInfo.is_group_buying = true
                    this.isShowGroupClassModal = false
                }
                if (classType === '공동구매 수업') {
                    this.makeScheduleInfo.is_group_buying = true
                } else {
                    this.makeScheduleInfo.is_group_buying = false
                }
                this.makeScheduleInfo.classType = classType
            },
            detectRegionSelect(region) {
                this.makeScheduleInfo.placeInfo = region
            },
            comma(e) {
                const target = e.currentTarget;
                const rgx1 = /[^\d]/g;
                const rgx2 = /(\d+)(\d{3})/;
                let num = target.value.replace(rgx1, "");

                while (rgx2.test(num)) num = num.replace(rgx2, '$1' + ',' + '$2');

                this.makeScheduleInfo.enterFee = num
            },
            comma2(e) {
                const target = e.currentTarget;
                const rgx1 = /[^\d]/g;
                const rgx2 = /(\d+)(\d{3})/;
                let num = target.value.replace(rgx1, "");

                while (rgx2.test(num)) num = num.replace(rgx2, '$1' + ',' + '$2');

                this.makeScheduleInfo.classCost = num
            },
            comma3(e) {
                const target = e.currentTarget;
                const rgx1 = /[^\d]/g;
                const rgx2 = /(\d+)(\d{3})/;
                let num = target.value.replace(rgx1, "");

                while (rgx2.test(num)) num = num.replace(rgx2, '$1' + ',' + '$2');

                this.makeScheduleInfo.groupClassCost = num
            },
        },
        created() {
            if (this.$Util.isShowDefaultSettings()) {
                return
            }
            this.makeMemberTalkSchedule = this.$Once(this.makeMemberTalkSchedule);
            this.makeSchedule = this.$Once(this.makeSchedule);

            if (this.scheduleIdx !== '') {
                this.isModify = true
                this.getScheduleDetail()
            } else {
                this.isLoaded = true;
                this.isOpenNowStart = true
            }
        },
    };
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }

    .fade-enter,
    .fade-leave-to

        /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .active {
        background-color: #210f03;
        color: #fff;
    }

    .un_active {
        background-color: #f5f5f5;
        color: #210f03;
    }

    .guide_box {
        width: 185px;
        height: 67px;
        display: flex;
        flex-direction: column;
        top: 44px;
        justify-content: space-between;
        padding: 8px;
        padding-bottom: 12px;
        border-radius: 10px;
        background: #fff;
        position: absolute;
        left: 31%;
        transform: translateX(-50%);
        z-index: 10;
        /* opacity: 1; */
        /* transition: all 0.5s; */
    }

    .class_fee::placeholder {
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #210f03;
    }

    .triangle {
        border-top: 0px solid transparent;
        border-left: 0px solid transparent;
        border-right: 30px solid transparent;
        border-bottom: 20px solid #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        content: "";
        position: absolute;
        top: -14px;
        left: 20%;
        transform: translateX(-50%);
    }

    .wrapper {
        display: flex;
        flex-direction: column;
    }

    .common_box {
        padding: 10px;
        border-radius: 12px;
        background-color: #f5f5f5;
    }

    .make_schedule_wrap .make_schedule {
        border-radius: 12px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background-color: #210f03;
        width: calc(100% - 24px);
        margin: 0 auto;
        color: #fff;
        font-weight: 700;
        font-size: 14px;
    }

    .active_btn {
        background-color: #210f03;
        color: #fff;
    }

    .un_active_btn {
        background-color: #f5f5f5;
        color: #d9d9d9;
    }

    .main_wrap {
        padding: 20px 12px;
        flex: 1;
        overflow-y: scroll;
        scroll-behavior: smooth;

    }

    .step1 {
        margin-bottom: 35px;
    }

    .common_text {
        font-weight: 700;
        font-size: 12px;
        margin-bottom: 8px;
    }

    .input_text.title {
        margin-bottom: 25px;
    }

    .input_text input::placeholder {
        font-weight: 700;
        color: #bbbbbb;
    }

    .input_text textarea::placeholder {
        font-size: 14px;
        color: #bbbbbb;
    }

    .input_text .text_area {
        outline: none;
        border: none;
        width: 100%;
        background-color: #f5f5f5;
        border-radius: 12px;
        padding: 12px;
    }

    .input_text .text_area::placeholder {
        font-size: 14px;
        font-weight: 500;
        color: #bbbbbb;
    }

    .input_text .count_text {
        float: right;
        margin-top: 6px;
        color: #bbbbbb;
        font-size: 12px;
        font-weight: 700;
    }

    .only_one {
        font-size: 12px;
        color: #606060;
        margin-top: 6px;
        font-weight: 500;
    }

    .step2 {
        margin-bottom: 20px;
    }

    .step3 {
        margin-bottom: 20px;
    }

    .schedule_box {
        background-color: #f5f5f5;
        border-radius: 12px;
        padding: 10px;
        font-weight: 500;
    }


    .schedule_box .common {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .schedule_box .time_picker .time_box {
        display: flex;
        align-items: center;
    }

    .common .title {
        font-size: 14px;
        white-space: nowrap;
    }

    .select_day img {
        width: 14px;
    }

    .time_picker img {
        width: 14px;
    }

    .arrow_img_wrap {
        position: absolute;
        right: 18px;
    }

    .arrow_img_wrap img {
        transform: rotate(90deg);
        width: 9px;
    }

    .select_day {
        border-bottom: 1px solid #ebebeb;
        padding-bottom: 8px;
        position: relative;
    }

    .select_day .select_sche {
        background-color: #fff;
        height: 44px;
        border-radius: 4px;
        line-height: 44px;
        text-align: center;
        font-size: 14px;
        width: 100%;
    }

    .time_picker {
        padding-top: 8px;
    }

    .time_box {
        flex: 1;
        display: flex;
        gap: 4px;
    }

    .time_box .select_time {
        flex: 1;
        height: 44px;
        background-color: #fff;
        border-radius: 4px;
        line-height: 44px;
        text-align: center;
    }

    .time_box .disable_time_box {
        flex: 1;
        height: 44px;
        background-color: #ebebeb;
        border-radius: 4px;
        line-height: 44px;
        text-align: center;
        pointer-events: none;
        color: #ebebeb;
    }

    .step4 {
        margin-bottom: 20px;
    }

    .step5 {
        margin-bottom: 20px;
    }

    .step5 .recruit_text {
        font-size: 12px;
        font-weight: 500;
        color: #606060;
        margin-top: 6px;
    }

    .step6 {}

    .step6 .pay_type {}

    .pay_img_wrap img {
        width: 20px;
    }

    .pay_type {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px;
    }

    .select_box .title {
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 4px;
    }

    .select_box .contents {
        font-size: 10px;
        font-weight: 500;
        color: #606060;
    }

    .one_select_text {
        font-weight: 500;
        font-size: 12px;
        color: #606060;
        margin-top: 6px;
    }

    .pay_box {
        border-top: 1px solid #ebebeb;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .pay_box .pay_input {
        border: none;
        outline: none;
        width: 100%;
        border-radius: 5px;
        padding: 10px;
        padding-right: 30px;
    }

    .pay_input_wrap {
        position: relative;
    }

    .pay_input_wrap .won {
        position: absolute;
        font-weight: 500;
        color: #606060;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
    }

    .pay_contents {
        font-size: 12px;
        font-weight: 500;
        color: #808080;
        line-height: 17px;
        margin-top: 4px;
    }

    .on_pay_fee {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .off_pay_fee {
        margin-bottom: 12px;
    }

    .on_border {
        border: 1px solid var(--color-main);
        margin-bottom: 12px;
        border-radius: 12px;
    }

    .on_border_free {
        border: 1px solid var(--color-main);
        border-radius: 12px;
    }

    .margin_top + .margin_top{margin-top:10px;}
    .introduc_del_btn{background-color:red; color:white; padding:10px; margin-top:5px; display:inline-block; border-radius:5px;}
    .add_btn{height:34px; display:grid; place-items:center; background-color: #4063ff; color:white;}
    .add_btn + .add_btn{margin-left: 10px;}
</style>
